import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from "react-redux";

import enMessages from './messages/en.json';
import arMessages from './messages/ar.json';

const allMessages = {
  en: enMessages,
  ar: arMessages,
};

export function I18nProvider({ children }) {
  const app = useSelector((state) => state.app.app)
  const messages = allMessages[app.locale];

  return (
    <IntlProvider locale={app.locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
